/**
 * 业绩考核周期服务
 */

import axios from 'axios';
import { PerformancePeriod } from './types';
import { getListResponse, API_BASE } from './utils';

export const performancePeriodService = {
    list: async (params?: { status?: string; period_type?: string }): Promise<PerformancePeriod[]> => {
        const response = await axios.get(`${API_BASE}/performance-periods/`, { params });
        return getListResponse(response.data);
    },

    get: async (id: number): Promise<PerformancePeriod> => {
        const response = await axios.get(`${API_BASE}/performance-periods/${id}/`);
        return response.data;
    },

    create: async (data: Partial<PerformancePeriod>): Promise<PerformancePeriod> => {
        const response = await axios.post(`${API_BASE}/performance-periods/`, data);
        return response.data;
    },

    update: async (id: number, data: Partial<PerformancePeriod>): Promise<PerformancePeriod> => {
        const response = await axios.patch(`${API_BASE}/performance-periods/${id}/`, data);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await axios.delete(`${API_BASE}/performance-periods/${id}/`);
    },

    activate: async (id: number): Promise<{ message: string }> => {
        const response = await axios.post(`${API_BASE}/performance-periods/${id}/activate/`);
        return response.data;
    },

    close: async (id: number): Promise<{ message: string }> => {
        const response = await axios.post(`${API_BASE}/performance-periods/${id}/close/`);
        return response.data;
    },
};
